const buyerOpen = {
    namespaced: true,
    state: {
        platformIsClosed : false
    },
    actions: {
        getIsPlatformClosed({commit, rootState}){
            rootState.axios.get('/api/getIsPlatformClosed').then(res =>{
                commit('IS_PLATFORM_CLOSED',res.data.payload.isClosed);
            })
        }
    },
    mutations: {
        IS_PLATFORM_CLOSED:(state, payload)=>{
            state.platformIsClosed = payload;
        }
    },
    getters:{
        getIsPlatformClosed:(state)=>{
            return state.platformIsClosed;
        }
    }

}

export default buyerOpen;